import { render, staticRenderFns } from "./important.vue?vue&type=template&id=d79be7aa&"
import script from "./important.vue?vue&type=script&lang=js&"
export * from "./important.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d79be7aa')) {
      api.createRecord('d79be7aa', component.options)
    } else {
      api.reload('d79be7aa', component.options)
    }
    module.hot.accept("./important.vue?vue&type=template&id=d79be7aa&", function () {
      api.rerender('d79be7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/important.vue"
export default component.exports